<template>
  <div class="balance">
    <div class="new-campaign">
      <div class="container">
        <div class="header-wrap">
          <h2>{{ $t("balance.newAdress") }}</h2>
        </div>

        <div class="creation-wrap">
          <form @submit="create_payment_customer" class="form" method="post">
            <div class="creation-block" style="margin: 0">
              <h3>{{ $t("global.company") }}</h3>
              <div class="form-wrap">
                <input v-model="payment_customer.metadata.company" class="form-input" type="text" name="name" id="name" placeholder="Mustermann GmbH" />
              </div>
            </div>

            <div class="creation-block" style="margin: 0">
              <h3>{{ $t("global.name") }}</h3>
              <div class="form-wrap">
                <input v-model="payment_customer.name" class="form-input" type="text" name="name" id="name" placeholder="Max Mustermann" />
              </div>
            </div>

            <div class="creation-block" style="margin: 0">
              <h3>{{ $t("global.street") }} {{ $t("global.and") }} {{ $t("global.housenumber") }}</h3>
              <div class="form-wrap">
                <input v-model="payment_customer.street" class="form-input" type="text" name="name" id="name" placeholder="Musterstraße 22" />
              </div>
            </div>

            <div class="row row-gutter-20">
              <div class="col-8">
                <div class="creation-block" style="margin: 0">
                  <h3>{{ $t("global.postalcode") }}</h3>
                  <div class="form-wrap">
                    <input v-model="payment_customer.metadata.zip_code" class="form-input" type="text" name="name" id="name" placeholder="12345" />
                  </div>
                </div>
              </div>
              <div class="col-16">
                <div class="creation-block" style="margin: 0">
                  <h3>{{ $t("global.city") }}</h3>
                  <div class="form-wrap">
                    <input v-model="payment_customer.metadata.city" class="form-input" type="text" name="name" id="name" placeholder="Musterstadt" />
                  </div>
                </div>
              </div>
            </div>

            {{ errors }}

            <p>
              <input type="submit" :value="$t('global.createNow')" class="button button-ci button-round button-100" />
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../../store";

export default {
  name: "new_balance_customer",
  data() {
    return {
      errors: [],
      user: {},
      payment_customer: {
        name: "",
        metadata: {
          company: "",
          street: "",
          zip_code: "",
          city: "",
        },
      },
    };
  },
  methods: {
    get_user() {
      axios
        .get(process.env.VUE_APP_BASE_API + "/user", {
          headers: { Authorization: store.getters.getToken },
        })
        .then((response) => {
          this.user = response.data.user;
        });
    },
    create_payment_customer: function (e) {
      e.preventDefault();

      axios
        .post(
          process.env.VUE_APP_BASE_API + "/user/payment_customers",
          {
            name: this.payment_customer.name,
            metadata: this.payment_customer.metadata,
          },
          { headers: { Authorization: store.getters.getToken } }
        )
        .then((response) => {
          console.log(response);
          this.$router.push("/balance");
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
  },
  mounted() {
    this.get_user();
  },
};
</script>

<style>
.content-wrap {
  min-height: 200px;
}

p.balance {
  margin: 0;
  font-size: 30px;
}
</style>
